import React, { useEffect } from "react";
import { Button, Header, Grid, Segment, GridRow } from "semantic-ui-react";
import { formatMoney } from "../../../../app/util/formatUtils";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { encryptValue } from "../../../../app/util/decryptUtil";

const styleSubHeader = {
  marginTop: "0.4em",
};
const CuentaCard = ({ cuenta }) => {
  return (
    <Segment>
      <Grid stackable columns={2} style={{ marginTop: "0.1em" }}>
        <GridRow>
          <Grid.Column width={10}>
            <Header as="h4" color="blue" textAlign="left">
              {cuenta.nombreTipoProductoCuenta}
              <Header.Subheader style={styleSubHeader}>
                {`Número de cuenta: ${cuenta.numeroCuenta}`}
              </Header.Subheader>
              <Header.Subheader style={styleSubHeader}>
                {`Monto disponible: ${cuenta.nombreMoneda} ${formatMoney(
                  cuenta.saldoDisponible
                )}`}
              </Header.Subheader>
            </Header>
          </Grid.Column>
          <Grid.Column width={4}>
            <GridRow>
              <Button
                color="yellow"
                size="large"
                content="Ver detalle"
                fluid
                as={Link}
                to={`cuentas/${encryptValue(cuenta.numeroCuenta)}`}
              />
              {/* <Button
                color="yellow"
                size="large"
                content="Ver detalle"
                fluid
                as={Link}
                to={`cuentas/${cuenta.numeroCuenta}`}
              /> */}
            </GridRow>
          </Grid.Column>
        </GridRow>
      </Grid>
    </Segment>
  );
};

CuentaCard.propTypes = {
  cuenta: PropTypes.object.isRequired,
};

export default CuentaCard;
